import { render, staticRenderFns } from "./footerCom.vue?vue&type=template&id=7f977549&scoped=true"
import script from "./footerCom.vue?vue&type=script&lang=js"
export * from "./footerCom.vue?vue&type=script&lang=js"
import style0 from "./footerCom.vue?vue&type=style&index=0&id=7f977549&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f977549",
  null
  
)

export default component.exports